// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountProcurementCard } from './account-procurement-card';
import { AccountPurchaseOrder } from './account-purchase-order';
import { ActiveStatus } from './active-status';
import { ApprovalTree } from './approval-tree';
import { ApprovalTreeAdminGroup } from './approval-tree-admin-group';
import { ProgramUserGroup } from './program-user-group';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ApprovalTreeUserGroup extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  getStatusParents() {
    return [this.programUserGroup];
  }

  getStatusId() {
    return this.activeStatusId;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK approvalTreeAdminGroup */
  approvalTreeAdminGroupId!: string;
  /** Guid key FK programUserGroup */
  programUserGroupId!: string;
  /** Guid FK accountProcurementCard */
  accountProcurementCardId?: string;
  /** Guid FK accountPurchaseOrder */
  accountPurchaseOrderId?: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Guid FK approvalTree */
  approvalTreeId!: string;
  /** DateTimeOffset */
  collectionReleasedTs?: Date;
  /** Int32 */
  orderTimeFrameDurationDays?: number;
  /** Int32 */
  orderTimeFrameShipByFromStartDays?: number;
  /** Int32 */
  orderTimeFrameStartDays?: number;
  /** Binary */
  rowVersion!: any;
  /** FK accountProcurementCardId */
  accountProcurementCard!: AccountProcurementCard;
  /** FK accountPurchaseOrderId */
  accountPurchaseOrder!: AccountPurchaseOrder;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK approvalTreeId */
  approvalTree!: ApprovalTree;
  /** FK approvalTreeAdminGroupId */
  approvalTreeAdminGroup!: ApprovalTreeAdminGroup;
  /** FK programUserGroupId */
  programUserGroup!: ProgramUserGroup;
}

